package top.wcpe.allincore.ui.runtime.ir.api

import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.host.AnimationHost
import top.wcpe.allincore.ui.runtime.host.UiExecutor
import top.wcpe.allincore.ui.runtime.host.UiTask

/** DSL 元素命令 API（特性②）。 */
class UiCommandApi(private val host: AnimationHost?, private val renderExecutor: UiExecutor?) {
    /** 按 id 解析元素；找不到返回携带 null 元素的句柄（方法调用安全 no-op）。 */
    fun find(id: String): ElementHandle = ElementHandle(id, host?.findElementById(id), renderExecutor)

    /** 元素命令句柄：持有目标元素 + 渲染线程执行器。 */
    class ElementHandle(
        private val id: String,
        private val element: UIElement<*>?,
        private val renderExecutor: UiExecutor?,
    ) {
        fun id(): String = id
        fun element(): UIElement<*>? = element
        fun exists(): Boolean = element != null

        /** 把写动作 post 回渲染线程执行；executor 为 null 时内联执行；元素为 null 时忽略。 */
        fun post(action: UiTask?) {
            if (element == null || action == null) return
            if (renderExecutor != null) renderExecutor.execute(action) else action.run()
        }
    }
}
